<template>
  <div class="buy_lamp_page">
    <div class="banner">
      <img v-lazy="productInfo.originalThumb" alt="">
    </div>
    <div class="info flex-between">
      <div class="titles">
        <div class="title">{{productInfo.title}}</div>
        <!-- <div class="subtitle">减少布线烦恼，提供自助开台服务</div> -->
      </div>
      <div class="price">
        <span class="num">{{productInfo.price}}</span>
        <span>元／件</span>
      </div>
    </div>
    <div class="sys-detail" v-html="productInfo.about"></div>
    <div class="buybar bcw">
      <div class="buy-footer flex-between">
        <van-stepper v-model="value" />
        <div>
          <span>总价：</span>
          <span>{{costPrice}}元</span>
        </div>
        <van-button round type="primary" class="buy-btn" @click="toBuy">立即购买</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Stepper, Toast, Lazyload } from 'vant';
Vue.use(Stepper).use(Toast).use(Lazyload);
export default {
  data() {
    return {
      value: 1,
      productInfo: {},
      detail: 'Aenean auctor dictum purus, et sollicitudin leo ornare sed. Morbi suscipit ut orci eget varius. Sed ut sollicitudin dui, ac viverra nulla. Proin rutrum, mi vehicula ornare sodales, nisi augue venenatis urna, a dignissim mauris elit non lectus. Cras posuere urna vel purus elementum elementum. Praesent mollis, ipsum vel malesuada tincidunt, turpis tortor finibus nulla, id laoreet neque quam vel massa. Curabitur non ullamcorper nibh. Maecenas venenatis viverra est, id porta arcu. Curabitur a iaculis orci, non iaculis urna. Maecenas ut maximus nibh, in tincidunt urna. Proin ullamcorper malesuada libero at posuere. Suspendisse posuere, turpis id tempus vehicula, neque velit fermentum nibh, vitae consectetur metus metus sed nisi. Aenean sed orci et ipsum malesuada volutpat.'
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    },
    costPrice() {
      return this.productInfo.price ? Number(this.productInfo.price)*this.value : 0
    }
  },
  methods: {
    toBuy() {
      this.$http.post('order/create',{
        targetId: this.id,
        targetType: 'product',
        targetNum: this.value
      }).then(res => {
        if(!res.data.code){
          let order = res.data.value
          location.href = `${location.origin}/m/pay_page?orderId=${order.id}&sn=${order.sn}&redirect=${encodeURIComponent(location.origin + '/venue/#/clubLamp')}`;
        }else{
          Toast.fail(res.data.message)
        }
      })
    },
    _getInfo() {
      this.$http.post('product/getClubServiceInfo',{
        productId: this.id
      }).then(res => {
        if (res.data.code) {
          Toast.fail(res.data.message)
        } else {
          this.productInfo = res.data.value
        }
      })
    }
  },
  created() {
    this._getInfo()
  }
}
</script>

<style lang='less'>
.buy_lamp_page {
  padding-bottom: 40px;
  .flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .banner {
    height: 200px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .info {
    padding: 10px 20px;
    border-bottom: 1px solid #eee;
    .title {
      font-size: 17px;
      font-weight: 700;
      line-height: 2;
    }
    .price {
      font-size: 14px;
      .num {
        font-size: 24px;
        font-weight: 500;
        color: #56D176;
      }
    }
  }
  .sys-detail {
    padding: 10px 20px;
  }
  .buy-footer {
    width: 100%;
    height: 44px;
    border-top: 1px solid #eee;
    padding: 0 20px;
    background: #fff;
    .buy-btn {
      height: 30px;
      line-height: 1;
    }
  }
  // @supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  //   .buy-footer {
  //     padding-bottom: constant(safe-area-inset-bottom);
  //     padding-bottom: env(safe-area-inset-bottom);

  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/pages/clubAdmin/lampControl/buyLampSys.vue